export const STATUS_TO_ICON = {
  Done: {
    iconName: 'check_circle_outline',
    iconColor: 'green',
  },
  Error: {
    iconName: 'error_outline',
    iconColor: 'red',
  },
  Started: {
    iconName: 'schedule',
    iconColor: 'black',
  },
  Running: {
    iconName: 'sync',
    iconColor: 'black',
  },
  Pending: {
    iconName: 'pending_actions',
    iconColor: 'black',
  },
  Fallback: {
    iconName: 'help_outline',
    iconColor: 'black',
  },
};
